import React from 'react';
export default (props) => (
    <section className="kompetens">
        <h3>{props.translation.kompetens}</h3>
        {Object.keys(props.kompetens).map( key => <React.Fragment key={key}>
            <h4>{props.translation[key]}</h4>
            <p>{props.kompetens[key].join(', ')}</p>
        </React.Fragment>)}
    </section>
)